export enum AuditLogOperation {
  Viewed = 'viewed',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
}
